import React from "react";
import Button from "@mui/material/Button";
import { CustomAlert, showToastAlert } from "./components/CustomAlert";
import { useSelector } from "react-redux";
import { sendMailService } from "../services/adminMail";

const mailActions = [
    { label: "Send mail to students for onboarding", key: "student_onboard" },
    { label: "Send mail to employers for onboarding", key: "employer_onboard" },
    { label: "Send mail to students for available internships", key: "student_available_internships" },
    { label: "Send mail to students for resume update", key: "student_update_resume" }
];

const AdminMailList = () => {
    const admin = useSelector((state) => state.admin);
    
    const handleSendMail = async (type) => {
        if (!window.confirm(`Are you sure you want to send the "${type}" mail?`)) {
            return;
        }
        const response = await sendMailService(admin.token, type);
        if(response.status === 200) {
            showToastAlert(`Mail sent to ${type}`, "success");
        } else {
            showToastAlert(`Failed to send mail to ${type}`, "error");
        }
    };

    return (
        <div>
            <h1 className="page-title-1 my-3 asdsd">Mails</h1>
            <table style={{ width: "100%", marginBottom: "2rem", borderCollapse: "collapse" }}>
                <tbody>
                    {mailActions.map((action) => (
                        <tr key={action.key}>
                            <td style={{ padding: "1rem", border: "1px solid #ddd" }}>
                                {action.label}
                            </td>
                            <td style={{ padding: "1rem", border: "1px solid #ddd" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => handleSendMail(action.key)}
                                >
                                    Send Mail
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <CustomAlert />
        </div>
    );
};

export default AdminMailList;